'use client'
import { HorizontalProductListWidgetData, WidgetChild } from '@lastbrand/storefront-proto-registry/api/v1/widget'

import { PLTypedWidgetProps } from '@src/components/pl-base-widget'
import { usePLPageMeta } from '@src/components/pl-page-context'
import { IProductCard } from '@src/components/product-card/product-card.types'
import LAYOUT_TYPES from '@src/quince-site-common/src/constants/layoutTypes'
import CustomSection from '@src/quince-site-common/src/domains/CustomSection'
import { ProductListThreeDS } from '@src/SectionRenderer/sections/productListThree'

import { toRichText } from '../widget-utils'

export function ProductRecommendationsDSWidget(props: PLTypedWidgetProps<HorizontalProductListWidgetData>) {
  const data = props.data.horizontalProductListData
  const rtHeading = toRichText(data?.heading)
  const headings = rtHeading ? [rtHeading] : []
  const pageMeta = usePLPageMeta()

  const productCards: IProductCard[] = props.children
    .map((child: WidgetChild) => {
      if (!child.data?.productItem) {
        return null
      }
      const productCardData = child.data.productItem
      return { product: productCardData } as unknown as IProductCard
    })
    .filter((card): card is IProductCard => card !== null)

  return (
    <ProductListThreeDS
      sectionConfig={
        new CustomSection({
          tracker: `collection_page__${pageMeta.seoData?.slug}`,
          id: props.id || '',
          richTexts: headings,
          productCards,
          title: '',
          classNames: [],
          influencers: [],
          layoutType: LAYOUT_TYPES.DEFAULT,
          baseDynamicClasses: [],
          mobileDynamicClassesOverrides: [],
          classNamesMobileOverrides: [],
        })
      }
    />
  )
}
